module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAYCAYAAADtaU2/AAAAAXNSR0IArs4c6QAAAQ5JREFUSA291LsNwjAQBuA4VHQZxbBBSko2CJPBBpSU2QAySjoqFPxbOQuM4+eFk5Djk3OfLjYW1R9if3uchajk6zm2w7EdQdZruzPaKUdutk1P3qrwB0qeRA4TQRnu0YEaYpqqyyod+1DS2TsOoej2ftidWOFYFF2zwSkoG5yKAv46XPLaN0imRA6K+gYGij84CsXCuSjq6z0mVM0lknTy8LwUJShqChslyIeXojDq+f7UnRKKUV3qneuzc6CoX6vOBjy4wsa5UFh6j2MK6sXqK2B0hW9rXOvNBRLCXS9TLhXFewbGJAfPQX/gVDwXdcKxeAm6CIfwUtQLL+EcaBC2cS4UdaMCpx2/qMWRi94VNLy6nNtA8wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_checkmark_reseller.png
// module id = 136
// module chunks = 0